import React, { Component } from "react"
import gql from "graphql-tag"
import { debounce } from "lodash"
import { Input, Alert, Row, Col } from "reactstrap"
import "./DriverSearch.css"
import { Link } from "react-router-dom"

import withApolloClient from '../withApolloClient'

const AvailableCarsQuery = gql`query AvailableCarsQuery($searchTerm: String,$driverId:ID) {
    availableCars(,searchTerm:$searchTerm,driverId:$driverId){
        edges{
            node{
                id
                pk
                carModel{
                    id
                    make
                    name
                    series
                    groupType{
                        id
                        name
                    }
                }
                dmvPlate
                year
                color
                group
                vin  
            }      
          }
    } }`


class CarSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        const { apolloClient } = this.props
        this.updateCarSearchInput("")
    }

    updateCarSearchInput = debounce((searchTerm) => {
        let driverId = this.props.driverId
        this.setState({ loading: true })
        this.props.apolloClient.query({
            query: AvailableCarsQuery,
            variables: { searchTerm, driverId, first: 60 }
        }).then((result) => {
            this.setState({ loading: false })
            if (result.data && result.data.availableCars && result.data.availableCars.edges && result.data.availableCars.edges.length > 0) {
                const uniqueCarsMap = new Map()
                result.data.availableCars.edges.forEach(car => {
                    uniqueCarsMap.set(car.node.id, car)
                })
                this.setState({ carSuggestions: Array.from(uniqueCarsMap.values()) })
            }
        })
    }, 500)

    render() {
        return (
            <div className="search">
                <span className="d-flex flex-row align-middle position-relative">
                    <Input type="text" onChange={(e) => this.updateCarSearchInput(e.target.value)} name="driverSearch" id="driverSearch" placeholder="Search by Car ID, VIN, Plate" />
                    {this.state.loading &&
                        <div className="snippet" data-title="dot-pulse" style={{ position: "absolute", right: 30, top: 15 }} >
                            <div className="stage">
                                <div className="dot-pulse"></div>
                            </div>
                        </div>
                    }
                </span>
                <div className="option-list">
                    {this.state.loading ? (
                        <Alert color="warning">
                            Loading cars please wait.</Alert>
                    ) : this.state.carSuggestions?.length > 0 ? (
                        this.state.carSuggestions.map((car, index) => (
                            <Row key={index} className="option" onClick={() => this.props.setCar(car.node.id)}>
                                <Col>
                                    <div className="option-list-wrapper-text" style={{ margin: "-5px" }}>
                                        <p>
                                            {car.node.year}{" "}
                                            {car.node.carModel?.make}{" "}
                                            {car.node.carModel?.name}{" "}
                                            {car.node.carModel?.series && `(${car.node.carModel.series})`}
                                        </p>
                                        <small>
                                            {car?.node?.pk || ""} - {car?.node?.vin || ""} - {car?.node?.dmvPlate || ""}
                                        </small>
                                    </div>
                                </Col>
                            </Row>
                        ))
                    ) : (
                        <Alert color="warning">
                            There are no cars available at the moment. Please try later.
                        </Alert>
                    )}
                </div>
            </div>
        )
    }
}


export default withApolloClient(CarSearch)
